import React, { useState } from 'react';
import { IonCardContent, IonCard, IonIcon } from '@ionic/react';
import { locationOutline, locationSharp } from 'ionicons/icons';

type PlaceMarkerProps = {
  name: string;
  lat: number;
  lng: number;
}

export const PlaceMarker = ({ name } : PlaceMarkerProps) => {
  const [detail, setDetail] = useState(false);

  return (
    <React.Fragment>
      <div style={{
        position: "relative",
        left: "-15px",
        top: "-30px"
      }}>
        <IonIcon
          size="large"
          ios={locationOutline}
          md={locationSharp}
          onClick={() => setDetail(!detail)}
        ></IonIcon>
      </div>
      {detail && <IonCard className="place-marker"  style={{
        position: "relative",
        left: "-15px",
        top: "-30px"
      }}>
        <IonCardContent>
          {name}
        </IonCardContent>
      </IonCard>}
    </React.Fragment>
  );
}